export default "__VITE_ASSET__CYfSmd43__"